import { useSuspenseQuery } from '@tanstack/react-query';

import api from 'src/axios';
import { QUERY_KEY_SCOPE_PURCHASE_PRODUCTS } from 'src/keys';

type ScopePurchaseProducts = string[];

export function useScopePurchaseProductsQuery() {
  return useSuspenseQuery<ScopePurchaseProducts>({
    queryKey: [QUERY_KEY_SCOPE_PURCHASE_PRODUCTS],
    queryFn: async () => {
      const { data } = await api.get('/products/scope-purchase-or-destocking');
      return data;
    },
  });
}
